import { IconButton, Tooltip } from '@mui/material';
import React from 'react';
import editIcon from '../../assets/svgs/edit.svg';
import trashIcon from '../../assets/svgs/trash.svg';

import { useSelector } from 'react-redux';
import StatusToggle from './promotions/StatusToggle';

/**
 * Reusable component for table row actions (edit, delete, toggle status)
 * @param {Object} props 
 * @param {string} props.type - 'promotion', 'discount', 'coupon', etc.
 * @param {Object} props.item - The row data
 * @param {Function} props.onEdit - Edit handler
 * @param {Function} props.onDelete - Delete handler
 * @param {boolean} props.showStatus - Whether to show status toggle
 * @param {Function} props.onStatusChange - Status change handler (optional)
 */
const TableActions = ({
   type,
   item,
   onEdit,
   onDelete,
   showStatus = false,
   onStatusChange
}) => {
   const { short_code } = useSelector((state) => state.app);
   const canEdit = true;


   return (
      <div className="flex items-center space-x-2">
         {showStatus && canEdit && (
            <StatusToggle
               type={type}
               item={item}
               onToggleComplete={onStatusChange}
            />
         )}

         {canEdit && (
            <>
               <Tooltip title="Edit">
                  <IconButton
                     size="small"
                     onClick={() => onEdit(item)}
                     className="text-gray-600 hover:text-blue-500"
                  >
                     <img src={editIcon} alt="Edit" className="w-5 h-5" />
                  </IconButton>
               </Tooltip>

               <Tooltip title="Delete">
                  <IconButton
                     size="small"
                     onClick={() => onDelete(item)}
                     className="text-gray-600 hover:text-red-500"
                  >
                     <img src={trashIcon} alt="Delete" className="w-5 h-5" />
                  </IconButton>
               </Tooltip>
            </>
         )}
      </div>
   );
};

export default TableActions;